import type { InventoryItemDefinition } from '../domain/types';

export const inventoryItems: Record<string, InventoryItemDefinition> = {
  emptyGrainSack: {
    id: 'emptyGrainSack',
    name: 'Den tomme kornsæk',
    shortDescription: 'En tom sæk mærket Den Smidtske Gård.',
    longDescription:
      'En solid sæk af groft stof. På mærket står “Den Smidtske Gård”. Her begynder kornets vej til møllen og bageren. Du fik sækken, da de fire erhverv fandt deres symboler på Rådhustorvet.',
    iconAssetId: 'grain-sack-icon',
    sourceSceneId: 'raadhustorvet-scene',
    fictionLabel: 'Fiktiv spilgenstand til Det store fjordbal.',
  },
  packedLunch: {
    id: 'packedLunch',
    name: 'Madpakken',
    shortDescription: 'En enkel madpakke til turen gennem Vejle.',
    longDescription:
      'Brød og lidt godt pakket ind til turen. Måske er der en anden, der er mere sulten.',
    iconAssetId: 'packed-lunch-icon',
    fictionLabel: 'Fiktiv spilgenstand til demoens byttegåder.',
  },
  austrianSoldierKnife: {
    id: 'austrianSoldierKnife',
    name: 'Soldatens kniv',
    shortDescription: 'En kniv med et slidt træskæfte.',
    longDescription: 'En enkel feltkniv, som soldaten lagde fra sig, da du gav ham madpakken.',
    iconAssetId: 'knife-icon',
    sourceSceneId: 'soldaterboegen-scene',
    historicalNote:
      'HISTORISK TEKST SKAL REVIEWES før genstanden knyttes til en virkelig hændelse.',
    fictionLabel: 'Fiktiv spilgenstand til den tekniske demo.',
  },
};
